import React, { useState, useImperativeHandle, forwardRef } from 'react';
import { Folder, Plus, Trash2, X, Calendar } from 'lucide-react';
import { api } from '../services/api';

const ProjectManager = forwardRef(({ currentProject, projects, onLoadProject, onProjectCreate, onDeleteProject }, ref) => {
    const [isOpen, setIsOpen] = useState(false);
    const [view, setView] = useState('list'); 
    const [newProjData, setNewProjData] = useState({ projectName: '', projectStartDate: new Date().toISOString().split('T')[0] });

    useImperativeHandle(ref, () => ({
        setIsOpen: (val) => { setIsOpen(val); setView('list'); }
    }));

    if (!isOpen) return null;

    const handleCreate = () => {
        if (!newProjData.projectName) return;
        if (typeof onProjectCreate === 'function') onProjectCreate(newProjData);
        setNewProjData({ projectName: '', projectStartDate: new Date().toISOString().split('T')[0] });
        setView('list');
        setIsOpen(false);
    };

    const copyIcalLink = (id) => {
        const link = `${window.location.protocol}//${window.location.hostname}:3001/api/projects/${id}/ics`;
        navigator.clipboard.writeText(link);
        alert('Calendar Link Copied! Add this URL to Google Calendar or Outlook.');
    };

    return (
        <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black bg-opacity-50 p-4">
            <div className="bg-white rounded-xl shadow-2xl w-full max-w-2xl overflow-hidden flex flex-col max-h-[80vh]">
                <div className="p-4 border-b flex justify-between items-center bg-gray-50">
                    <h3 className="font-bold text-lg text-gray-800 flex items-center gap-2"><Folder className="text-blue-600"/> Project Manager</h3>
                    <button onClick={() => setIsOpen(false)}><X size={24} className="text-gray-400 hover:text-gray-600"/></button>
                </div>

                <div className="p-4 flex-1 overflow-y-auto">
                    {view === 'list' ? (
                        <div className="space-y-4">
                            <button onClick={() => setView('new')} className="w-full py-3 border-2 border-dashed border-blue-200 rounded-lg text-blue-600 font-bold hover:bg-blue-50 flex items-center justify-center gap-2">
                                <Plus size={20}/> Create New Project
                            </button>
                            <div className="space-y-2">
                                {projects.map(p => (
                                    <div key={p.id} className={`flex justify-between items-center p-3 rounded-lg border ${currentProject?.id === p.id ? 'bg-blue-50 border-blue-300' : 'bg-white hover:bg-gray-50'}`}>
                                        <div className="cursor-pointer flex-1" onClick={() => { onLoadProject(p.id); setIsOpen(false); }}>
                                            <div className="font-bold text-gray-800">{p.name}</div>
                                            <div className="text-xs text-gray-500">Started: {p.start_date}</div>
                                        </div>
                                        <button onClick={() => copyIcalLink(p.id)} className="p-2 text-gray-400 hover:text-blue-500" title="Copy Calendar Sync Link"><Calendar size={16}/></button>
                                        <button onClick={() => onDeleteProject(p.id)} className="p-2 text-gray-400 hover:text-red-500"><Trash2 size={16}/></button>
                                    </div>
                                ))}
                                {projects.length === 0 && <div className="text-center text-gray-400 py-8">No projects found.</div>}
                            </div>
                        </div>
                    ) : (
                        <div className="space-y-4">
                            <div><label className="block text-sm font-bold text-gray-700 mb-1">Project Name</label><input className="w-full border rounded p-2" autoFocus value={newProjData.projectName} onChange={e => setNewProjData({...newProjData, projectName: e.target.value})} /></div>
                            <div><label className="block text-sm font-bold text-gray-700 mb-1">Start Date</label><input type="date" className="w-full border rounded p-2" value={newProjData.projectStartDate} onChange={e => setNewProjData({...newProjData, projectStartDate: e.target.value})} /></div>
                            <div className="flex gap-2 pt-4">
                                <button onClick={() => setView('list')} className="flex-1 py-2 border rounded text-gray-600 hover:bg-gray-50">Cancel</button>
                                <button onClick={handleCreate} className="flex-1 py-2 bg-blue-600 text-white rounded font-bold hover:bg-blue-700">Create Project</button>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
});

export default ProjectManager;